import axios from "axios";
import Config from "../config";

const getRoomByUser = id => {
    return axios({
        method: "post",
        url: (Config.url || '') + "/api/room/join-by-user",
        data: { id }
    });
};

export default getRoomByUser;
